import React, { useState, useEffect } from "react";

const MediaHandler = ({
  url,
  className,
  onExpand,
  isExpanded,
}: {
  url: string;
  className: string;
  onExpand: () => void;
  isExpanded: boolean;
}) => {
  const [mediaState, setMediaState] = useState({
    isImage: false,
    shouldTryVideo: false,
    hasError: false,
  });

  useEffect(() => {
    setMediaState({
      isImage: false,
      shouldTryVideo: false,
      hasError: false,
    });
  }, [url]);

  const handleImageError = () => {
    console.log("Image error triggered trying video:", { url });
    setMediaState((prev) => ({
      ...prev,
      isImage: false,
      shouldTryVideo: true,
    }));
  };

  const handleImageLoad = () => {
    console.log("Image loaded successfully:", { url });
    setMediaState((prev) => ({
      ...prev,
      isImage: true,
    }));
  };

  const handleVideoError = () => {
    setMediaState((prev) => ({
      ...prev,
      hasError: true,
    }));
  };

  const getMediaClassName = () => {
    const baseClasses = "rounded-lg cursor-pointer";

    if (mediaState.shouldTryVideo && !mediaState.isImage) {
      return `${baseClasses} w-48 ${isExpanded ? "w-full" : ""}`;
    }

    return `${baseClasses} ${className}`;
  };

  if (mediaState.hasError) {
    return <p>Media is unavailable</p>;
  }

  if (!mediaState.shouldTryVideo) {
    return (
      <img
        src={url}
        alt="Media content"
        className={className}
        onClick={onExpand}
        onLoad={handleImageLoad}
        onError={handleImageError}
      />
    );
  }

  if (mediaState.shouldTryVideo && !mediaState.isImage) {
    return (
      <video
        src={url}
        className={getMediaClassName()}
        controls
        onError={handleVideoError}
      />
    );
  }

  return null;
};

export default MediaHandler;
